import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const RoleRedirect = () => {
  const { isAuthenticated, user } = useSelector(state => state.Login);

  if (!isAuthenticated) return <Navigate to="/signin" replace />;

  const role = Number(user?.role ?? 3);
  return <Navigate to={[3, 4].includes(role) ? "/home" : "/dashboard"} replace />;
};

export default RoleRedirect;
